import { Typography } from "@mui/material";
import React, { useEffect } from "react";
import styles from "./formCategory.module.css";
import Grid from "@mui/material/Grid";
import TextField from "component/textField/TextField";
import RadioWithInput from "component/inputs/radioWithInput/RadioWithInput";
import ValidationMessage from "component/validationMessage/ValidationMessage";

function StanbicAccount({ setValue, formData, register, watch, errors }) {
  const haveBankAccount = watch("haveBankAccount");

  useEffect(() => {
    if (haveBankAccount === "true") {
      setValue("accountCreationConsent", false);
    } else {
      setValue("bankAccount", "");
    }
  }, [haveBankAccount]);

  return (
    <div className={styles.category_tab}>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={4}>
          <div className={styles.category}>
            <Typography variant="h6">
              Do you have an account with Stanbic Bank{" "}
              <span style={{ color: "red" }}>*</span>
            </Typography>
            <Typography>
              Please provide the details required as they relate to your account
              details.
            </Typography>
          </div>
        </Grid>
        <Grid item xs={12} sm={8}>
          <div className={styles.category_form}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <RadioWithInput
                    inputPlaceholder="Account number"
                    inputName={"bankAccount"}
                    register={register}
                    name="haveBankAccount"
                    value={"true"}
                    result={haveBankAccount}
                    label="yes"
                    checked={formData.haveBankAccount}
                  />
                  <ValidationMessage
                    message={errors?.haveBankAccount?.message}
                  />
                  {haveBankAccount === "true" && (
                    <div>
                      {errors?.bankAccount && (
                        <ValidationMessage
                          message={errors?.bankAccount?.message}
                        />
                        // <Typography style={{ marginTop: 8, color: "red" }}>
                        //   {errors?.bankAccount?.message}
                        // </Typography>
                      )}
                    </div>
                  )}
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <div className={styles.radio_with_input}>
                    <label htmlFor="">
                      <input
                        {...register("haveBankAccount")}
                        value={"false"}
                        type="radio"
                        name="haveBankAccount"
                        id=""
                      />
                      no
                    </label>
                    {haveBankAccount === "false" && (
                      <>
                        <div className={styles.prompt}>
                          <input
                            {...register("accountCreationConsent")}
                            type="checkbox"
                            name="accountCreationConsent"
                            id=""
                          />
                          <Typography>
                            “I consent to the Stanbic Bank PLC Opening an
                            account in my name with the details I have provided
                            through the course of my mortgage application.
                          </Typography>
                        </div>

                        {errors?.accountCreationConsent && (
                          <ValidationMessage
                            message={errors?.accountCreationConsent?.message}
                          />
                          // <Typography style={{ marginTop: 8, color: "red" }}>
                          //   {errors?.accountCreationConsent?.message}
                          // </Typography>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

export default StanbicAccount;
